import { FC } from 'react';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { DismissedSuccessProps } from '../types';

export const DismissedSuccess: FC<DismissedSuccessProps> = ({
  DISMISS_NOTIFICATIONS_TOAST,
  handleDismissClose,
}) => {
  return (
    <CatInlineNotification
      variant="success"
      heading={DISMISS_NOTIFICATIONS_TOAST}
      dismissible
      data-testid="notification-dismissed-success-banner"
      close={handleDismissClose}
    >
      <CatIconWarningCircle slot="before" />
    </CatInlineNotification>
  );
};
